var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0V0z",
    fill: "#0D47A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4V0H0v9h4V6l3 3h2V7L6 4h3z",
    fill: "#F8F9FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 1V0H1v1H0v2h1v6h2V3h6V1H3z",
    fill: "#EF5350"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8L5 4H4l5 5V8z",
    fill: "#EF5350"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13l-1 .5v.5h-.5L5 15l-.5-1H4v-.5L3 13l1-.5V12h.5l.5-1 .5 1H6v.5l1 .5z",
    fill: "#F8F9FD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.06 12.62l.25.52.56-.13-.25.51.45.36-.56.12v.58l-.45-.36-.44.36V14l-.56-.12.45-.36-.25-.51.56.13.24-.52zM10.77 7.14l.24.52.56-.13-.25.51.45.36-.56.13v.57l-.44-.36-.45.36v-.57l-.56-.13.45-.36-.25-.51.56.13.25-.52zM13.06 4.01l.25.52.56-.13-.25.51.45.36-.56.12v.58l-.45-.36-.44.36v-.58l-.56-.12.45-.36-.25-.51.56.13.24-.52zM15.07 6.36l.25.52.56-.13-.25.51.44.36-.55.12v.58l-.45-.36-.45.36v-.58l-.55-.12.45-.36-.25-.51.55.13.25-.52zM13.64 9.1l.2.6h.62l-.5.37.19.6-.51-.38-.51.37.2-.6-.52-.36h.63l.2-.6z",
    fill: "#F8F9FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAu);
export default __webpack_public_path__ + "static/media/au.0212f716e661d8e234d4e86b57975c04.svg";
export { ForwardRef as ReactComponent };